"use client";

import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

interface SearchBarProps {
    mobile?: boolean;
    value: string;
    onChange: (value: string) => void;
    onSubmit?: () => void;
}

export function SearchBar({ mobile, value, onChange, onSubmit }: SearchBarProps) {
    const router = useRouter();

    const handleSearch = (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        if (!value.trim()) return;
        router.push(`/search?q=${encodeURIComponent(value)}`);
        if (onSubmit) onSubmit();
    };

    if (mobile) {
        return (
            <form onSubmit={handleSearch} className="relative">
                <Input
                    placeholder="Rechercher..."
                    className="h-11 pr-12 rounded-xl border-primary-300 text-primary-900 selection:bg-primary-200 selection:text-primary-900"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
                <button
                    type="submit"
                    className="absolute right-1 top-1/2 -translate-y-1/2 h-9 w-9 flex items-center justify-center rounded-lg bg-primary-500 text-white"
                    aria-label="Rechercher"
                >
                    <Search className="h-4 w-4" />
                </button>
            </form>
        );
    }

    return (
        <form
            onSubmit={handleSearch}
            className="flex flex-1 max-w-3xl mx-8 items-center border border-primary-200 rounded-lg overflow-hidden h-12 bg-white"
        >

            <div className="flex-1 flex items-center px-4 gap-3">
                <Search className="h-5 w-5 text-primary-400" />
                <Input
                    placeholder="Rechercher des produits..."
                    className="border-none focus-visible:ring-0 h-full text-sm text-primary-900 placeholder:text-primary-400 bg-transparent selection:bg-primary-200 selection:text-primary-900"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
            </div>



            <Button
                type="submit"
                className="h-full rounded-none px-8"
            >
                Rechercher
            </Button>

        </form>
    );
}